import dynamic from "next/dynamic";
import HubspotWithQuoteCarouselFormConfig from "./hubspot-with-quote-carousel-form-config";
import HubspotWithQuoteCarouselFormAdvancedConfig from "./hubspot-with-quote-carousel-form-advanced-config";
const HubspotWithQuoteCarouselFormComponent = dynamic(()=>import("./hubspot-with-quote-carousel-form-component"));
export default {
    HubspotWithQuoteCarouselFormComponent,
    HubspotWithQuoteCarouselFormConfig,
    HubspotWithQuoteCarouselFormAdvancedConfig
};
